var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{staticClass:"mr-3 mt-1",attrs:{"variant":"success"},on:{"click":function($event){return _vm.printCertificate()}}},[_vm._v(" Print Certificate ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }